import { useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";

// SVGs
import PlusSvg from "../../assets/assets_svg/addicon.svg";
import deleteSvg from "../../assets/assets_svg/delete.svg";
import AdminIcons from "../../assets/assets_img/admin_icons.png";

import ApproveMemberModal from "./ApproveMemberModal";
import { DeleteConformation } from "../DeleteConformation";
import { getApi, postApi } from "../../Helpers/Axios";
import { DateConverter } from "../../Helpers/Helper";
import { Pagination } from "../Pagination";
import { useSelector } from "react-redux";

import toast from "react-hot-toast";

const PendingMembers = () => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const admin = useSelector((state) => state?.auth?.user);
  const [memberData, setMemberData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [delId, setDelId] = useState(0);

  // Pagination assets
  const [dataCount, setDataCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [searchData, setSearchData] = useState("");

  const [previewImage, setPreviewImage] = useState(null);

  const [approveModal, setApproveModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  useEffect(() => {
    setIsLoadingData(true);
    fetchMember();
  }, [currentPage, searchData]);

  useEffect(() => {
    if (!modalShow) {
      fetchMember();
    }
  }, [modalShow]);

  const calculateAge = (dobString) => {
    const dob = new Date(dobString);
    const today = new Date();

    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    const dayDiff = today.getDate() - dob.getDate();

    // Adjust age if the birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age;
  };

  const fetchMember = async () => {
    let url =
      searchData !== ""
        ? `get-pending-member?page=${currentPage}&search=${searchData}`
        : `get-pending-member?page=${currentPage}`;
    await getApi(url, true).then((response) => {
      if (response.status === 200) {
        console.log("🚀 ~ awaitgetApi ~ response.data:", response.data);
        setMemberData(response.data);
        setDataCount(response.dataCount);
        setTotalPage(response.totalPage);
        setIsLoadingData(false);
      } else {
        setIsLoadingData(false);
      }
    });
  };

  const handleApproveStatus = async (id) => {
    console.log("🚀 ~ handleApproveStatus ~ id:", id);
    let url = `approve-member?status_id=${id}`;
    let bodyData = {};
    await postApi(url, bodyData, true)
      .then(async (response) => {
        if (response.status === 200) {
          toast.success("User Approved", {
            duration: 3000,
            position: "top-center",
          });
          fetchMember();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlePageChange = (pageNum) => {
    // Ensure the page number is within range
    if (pageNum < 1 || pageNum > totalPage) return;

    setCurrentPage(pageNum);
    // Perform any additional data fetching or state update logic here
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <p className="m-0 breadcrumbs">
          <span>
            <Link to={"/dashboard"}>Dashboard</Link> /
          </span>{" "}
          Pending Members
        </p>
        <div className="d-flex justify-content-between align-items-center">
          <input
            type="search"
            placeholder="Searching...."
            class="search-input me-3"
            name="title"
            value={searchData}
            onChange={(e) => setSearchData(e.target.value)}
          />
          {admin?.is_superadmin ? (
            <Link to={"/add-surname"}>
              <button className="theme-icon-btn float-end px-3">
                <img src={PlusSvg} alt="add icon" />
                Add
              </button>
            </Link>
          ) : (
            ""
          )}
        </div>
      </div>

      <div className="data-table mt-3">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Village</th>
              <th>Photo</th>
              <th>Name</th>
              <th>Father Name</th>
              <th>Grand Father Name</th>
              <th>Email</th>
              <th>Age/Gender</th>
              <th>Current City</th>
              <th>Mobile No</th>
              <th className="text-center" style={{ width: "140px" }}>
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {!isLoadingData ? (
              memberData?.length ? (
                memberData?.map((val, key) => {
                  console.log("🚀 ~ val:", val);
                  return (
                    <tr key={key}>
                      <td>{val?.id}</td>
                      <td>
                        {`${val?.villageData?.name_eng}`} <br />
                        {` ${val?.villageData?.name_gj}`}
                      </td>
                      <td>
                        {!!val?.profile_img ? (
                          <img
                            alt="profile_img"
                            src={`${process.env.REACT_APP_IMAGE_URL}${val?.profile_img}`}
                            style={{ height: 60, width: 60, borderRadius: 30 }}
                            onClick={() => setPreviewImage(`${process.env.REACT_APP_IMAGE_URL}${val?.profile_img}`)}
                          />
                        ) : (
                          <img alt="profile_img" src={AdminIcons} style={{ height: 60, width: 60, borderRadius: 30 }} />
                        )}
                      </td>
                      <td>
                        {`${val?.surnameData.name_eng} ${val?.name_en}`} <br />
                        {`${val?.surnameData.name_gj} ${val?.name_gj}`}
                      </td>
                      <td>
                        {`${val?.father_name_en}`} <br /> {`${val?.father_name_gj}`}
                      </td>
                      <td>
                        {`${val?.grand_father_name_en}`} <br /> {`${val?.grand_father_name_gj}`}
                      </td>
                      <td>{val?.email}</td>
                      <td
                        style={{
                          color: val?.gender === "men" ? "#305CDE" : val?.gender === "women" ? "#E11584" : "black",
                          fontWeight: "bold",
                        }}
                      >
                        {`${calculateAge(val?.dob)}/`}
                        {val?.gender === "men" ? "M" : val?.gender === "women" ? "F" : "-"}
                      </td>
                      <td>{`${val?.city}`}</td>
                      <td>{`${val?.mobile_1}`}</td>

                      <td className="d-flex justify-content-center">
                        {admin?.is_superadmin || admin?.id == 2 || admin?.id == 3 || admin?.id == 4 ? (
                          <div className="data-action m-1">
                            <button
                              className="btn btn-small btn-danger"
                              onClick={() => {
                                setModalShow(true);
                                setDelId(val.id);
                              }}
                            >
                              <img src={deleteSvg} alt="" />
                            </button>
                          </div>
                        ) : (
                          ""
                        )}
                        <button
                          className="btn btn-success m-1"
                          onClick={() => {
                            setSelectedMember(val);
                            setApproveModal(true);
                          }}
                        >
                          Approve
                        </button>
                      </td>
                    </tr>
                  );
                  // }
                })
              ) : (
                <tr className="text-center">
                  <td colSpan={12}>Not found</td>
                </tr>
              )
            ) : (
              <tr>
                <td colSpan={12} className="text-center">
                  Loading...
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Image Viewer Overlay */}
      {previewImage && (
        <div
          onClick={() => setPreviewImage(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            cursor: "zoom-out",
          }}
        >
          <img
            src={previewImage}
            alt="Preview"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
              boxShadow: "0 0 20px rgba(0,0,0,0.5)",
            }}
          />
        </div>
      )}

      {/* Render Pagination component */}
      <Pagination dataCount={dataCount} currentPage={currentPage} totalPage={totalPage} page={handlePageChange} />

      <ApproveMemberModal
        show={approveModal}
        onHide={() => setApproveModal(false)}
        member={selectedMember}
        onSuccess={fetchMember}
      />

      <DeleteConformation show={modalShow} onHide={() => setModalShow(false)} title="Member" url={`member/${delId}`} />
    </>
  );
};

export default PendingMembers;
